import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {LayoutService} from "../layout.service";

declare var $: any;

@Component({
  selector: 'sa-ribbon',
  templateUrl: './ribbon.component.html'
})
export class RibbonComponent implements OnInit {

  constructor(private layoutService: LayoutService, private router: Router) {}

  ngOnInit() {
  }

  resetWidgets() {
    //this.layoutService.factoryReset()
    let cmd = 'home';
    let idx = location.href.indexOf('/#/');
    if (idx > 0) cmd = location.href.substr(idx + 3);
    this.router.navigate(['home/blank']).then(s=>this.router.navigate([cmd]));
  }

  static oldButtonGroup = null;
  static takeInButtonGroup(buttonGroup) {
    if (RibbonComponent.oldButtonGroup) {
      $(RibbonComponent.oldButtonGroup).detach();
      RibbonComponent.oldButtonGroup = null;
    }
    if (buttonGroup) {
      $(buttonGroup).appendTo($("#ribbon"));
      RibbonComponent.oldButtonGroup = buttonGroup;
    }
  }

}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/ribbon/ribbon.component.ts